import React from 'react'
import { WHY_CHOOSE_STATS } from './../../content'

import './WhyChoose.component.scss'

const WhyChoose = () => (
  <section id='WhyChoose' className='subsite-section is-blue'>
    <div className='subsite-shell'>
      <h2 className='subsite-section-title'>Why Choose USA Benefits Group</h2>
      <div className='why-grid'>
        {WHY_CHOOSE_STATS.map((item, i) => (
          <div className='why-card' key={`why-${i}`}>
            <div className='why-stat'>{item.stat}</div>
            <div className='why-label'>{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default WhyChoose
